import { ArrowRight, CheckCircle, XCircle } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const AdvanceStageDialog = ({
  open,
  onOpenChange,
  stage,
  checks = [],
  onConfirm,
  busy = false,
}) => {
  const open_ = checks.filter((c) => !c.ok).length;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="advance-stage-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Advance to {stage}?</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-zinc-400" data-testid="advance-stage-summary">
          {open_} item{open_ === 1 ? " is" : "s are"} still open for this stage.
          You can advance anyway.
        </p>
        <ul className="space-y-1.5">
          {checks.map((c, i) => (
            <li
              key={i}
              data-testid={`advance-check-${i}`}
              data-ok={c.ok ? "1" : "0"}
              className="flex items-center gap-2 text-sm"
            >
              {c.ok ? (
                <CheckCircle size={16} weight="fill" className="shrink-0 text-emerald-400" />
              ) : (
                <XCircle size={16} weight="fill" className="shrink-0 text-red-400" />
              )}
              <span className={c.ok ? "text-zinc-500" : "text-zinc-100"}>{c.text}</span>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button
            type="button"
            variant="outline"
            data-testid="advance-cancel"
            onClick={() => onOpenChange(false)}
            disabled={busy}
          >
            Not yet
          </Button>
          <Button
            type="button"
            data-testid="advance-anyway"
            onClick={onConfirm}
            disabled={busy}
          >
            Advance anyway <ArrowRight size={14} weight="bold" className="ml-1.5" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
